import { useCallback } from "react";
import { personPreference } from "../local-storage/personPreference";

export type SidebarMode = "full" | "icons";

export const MENU_WIDTH_PX: Record<SidebarMode, number> = { full: 288, icons: 72 };

const sidebarModePreference = personPreference<SidebarMode>("sidebar-mode", ["full", "icons"], "full");

export const useSidebarMode = (personId: string) => {
  const [mode, setMode] = sidebarModePreference.use(personId);
  const toggle = useCallback(() => setMode(mode === "icons" ? "full" : "icons"), [mode, setMode]);
  return { mode, toggle };
};
